module.exports = __webpack_public_path__ + "img/ps-2.03c3b941.jpg";